import { createStore } from 'satcheljs';
import RecipientWellLinkedInStore from './schema/RecipientWellLinkedInStore';

var initialRecipientWellLinkedInStore: RecipientWellLinkedInStore = {
    bindingPromoClicked: false,
};
var store = createStore<RecipientWellLinkedInStore>(
    'linkedIn',
    initialRecipientWellLinkedInStore
)();

export default store;
